import i18n from '../i18n/i18n';
import { FORM_VALIDATOR_TYPES } from '../constants';
import { ICurriculumForm, ISemesterForm } from '../interface';

export const SEMESTER_INIT: ISemesterForm = {
  id: {
    value: null,
    isRequired: false,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  name: {
    value: '',
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  startDate: {
    value: null,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: false,
  },
  endDate: {
    value: null,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: false,
  },
};

export const CURRICULUM_FORM_INIT: ICurriculumForm = {
  name: {
    value: '',
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  description: {
    value: '',
    isRequired: false,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  status: {
    value: { label: i18n.t('msg.active', 'Active'), code: true },
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.OBJECT,
    disable: false,
  },
};
